export default __webpack_public_path__ + "static/media/linkedin.34aa610f.svg";